'use client'

import {
    createContext,
    useContext,
    useEffect,
    useState
} from 'react';

interface InstallPromptContextType {
    deferredPrompt: any;
    setDeferredPrompt: (v: any) => void;
}

const InstallPromptContext =
    createContext<InstallPromptContextType>({
        deferredPrompt: null,
        setDeferredPrompt: () => {}
    });

export const useInstallPromptContext = () =>
    useContext(InstallPromptContext);

export default function InstallPromptProvider({
    children
}: {
    children: React.ReactNode
}) {

    const [deferredPrompt, setDeferredPrompt] =
        useState<any>(null);

    useEffect(() => {

        const handler = (e: any) => {
            e.preventDefault();

            console.log('BIP fired');

            setDeferredPrompt(e);
        };

        window.addEventListener(
            'beforeinstallprompt',
            handler
        );

        return () => {
            window.removeEventListener(
                'beforeinstallprompt',
                handler
            );
        };

    }, []);

    return (
        <InstallPromptContext.Provider
            value={{
                deferredPrompt,
                setDeferredPrompt
            }}
        >
            {children}
        </InstallPromptContext.Provider>
    );
}